// extracted by mini-css-extract-plugin
export default {"container":"kX-z","title":"lX-z","link":"mX-z"};